export default __webpack_public_path__ + "static/media/Al-Ahly.50a883d8.svg";